import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import {
  Controller,
  FieldValues,
  Path,
  PathValue,
  useFormContext
} from 'react-hook-form';
import { CommonFieldProps } from '../form.types';

export type AutocompleteFieldProps<T extends FieldValues> =
  CommonFieldProps<T> & {
    type: 'autocomplete';
    options: string[];
    defaultValue?: PathValue<T, Path<T>>;
    onChange?: (
      event: React.SyntheticEvent<Element, Event>,
      value: string | string[] | null
    ) => void;
  };

export const AutocompleteField = <T extends FieldValues>({
  name,
  onChange,
  label,
  options,
  defaultValue
}: AutocompleteFieldProps<T>) => {
  const { control } = useFormContext<T>();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: typeField }) => (
        <Autocomplete
          options={options}
          value={typeof typeField.value === 'string' ? typeField.value : null}
          onBlur={typeField.onBlur}
          onChange={(event, value) => {
            // Call the form field's onChange first to update form state
            typeField.onChange(value);
            // Then call the custom onChange if provided
            onChange?.(event, value);
          }}
          renderInput={(params) => (
            <TextField {...params} label={label} inputRef={typeField.ref} />
          )}
        />
      )}
    />
  );
};
